import { createSelector } from 'reselect';

const getFiltersDevicesAccesor = state => state.stock.filters.devices;
const getFiltersSimcardsAccesor = state => state.stock.filters.simcards;
const getFiltersGpsAccesor = state => state.stock.filters.gps;

export const filtersDevicesSelector = createSelector(getFiltersDevicesAccesor, filters => filters);
export const filtersDevicesToUseInQuerySelector = createSelector(getFiltersDevicesAccesor, filters => {
    let _filters = {};

    if (filters.search !== undefined && filters.search !== null) {
        _filters.search = filters.search.toString();
    }

    if (filters.from_created) {
        _filters.from_created = filters.from_created;
    }

    if (filters.to_created) {
        _filters.to_created = filters.to_created;
    }

    if (filters.status && filters.status._id) {
        _filters.status = filters.status._id;
    }

    if (filters.substatus && filters.substatus._id) {
        _filters.substatus = filters.substatus._id;
    }

    if (filters.enabled && filters.enabled.value !== '') {
        _filters.enabled = filters.enabled.value;
    }

    return _filters;
});

export const filtersSimcardsSelector = createSelector(getFiltersSimcardsAccesor, filters => filters);
export const filtersSimcardsToUseInQuerySelector = createSelector(getFiltersSimcardsAccesor, filters => {
    let _filters = {};

    if (filters.search) {
        _filters.search = filters.search;
    }

    if (filters.from_created) {
        _filters.from_created = filters.from_created;
    }

    if (filters.to_created) {
        _filters.to_created = filters.to_created;
    }

    if (filters.status && filters.status._id) {
        _filters.status = filters.status._id;
    }

    if (filters.substatus && filters.substatus._id) {
        _filters.substatus = filters.substatus._id;
    }

    if (filters.enabled && filters.enabled.value !== '') {
        _filters.enabled = filters.enabled.value;
    }

    return _filters;
});

export const filtersGpsSelector = createSelector(getFiltersGpsAccesor, filters => filters);
export const filtersGpsToUseInQuerySelector = createSelector(getFiltersGpsAccesor, filters => {
    let _filters = {};

    if (filters.search && filters.search.length) {
        _filters.search = filters.search;
    }

    if (filters.date) {
        _filters.date = filters.date;
    }
    if (filters.status && filters.status._id) {
        _filters.status = filters.status._id;
    }

    if (filters.substatus && filters.substatus._id) {
        _filters.substatus = filters.substatus._id;
    }

    if (filters.enabled && filters.enabled.value !== '') {
        _filters.enabled = filters.enabled.value;
    }

    if (filters.assigned && filters.assigned.value !== null && typeof filters.assigned.value !== 'undefined') {
        _filters.assigned = filters.assigned.value;
    }

    if (filters.protocol && filters.protocol.value !== null && typeof filters.protocol.value !== 'undefined') {
        _filters.protocol = filters.protocol.value;
    }

    return _filters;
});
